module.exports = __webpack_public_path__ + "static/media/checkbox.184db152.svg";